// Shared "are trades currently allowed?" gate for the mobile UI, mirroring the desktop Trade view
// (see src/ui/views/Trade/index.tsx). Trades are blocked after the deadline through the playoffs,
// during fantasy/expansion drafts, once the game is over, when another team wants to hire the user
// away (job offer pending), in spectator mode, or when challengeNoTrades is on.
//
// otherTeamsWantToHire is only available as a prop on the Trade view, so callers that don't have it
// (roster/player screens) pass nothing — the destination Trade screen still enforces the full gate.

import { PHASE } from "../../common/constants.ts";
import { useLocal } from "./local.ts";

export const useNoTradingAllowed = (
	otherTeamsWantToHire?: boolean,
): boolean => {
	const { phase, gameOver, spectator, challengeNoTrades } = useLocal([
		"phase",
		"gameOver",
		"spectator",
		"challengeNoTrades",
	]);

	return (
		(phase >= PHASE.AFTER_TRADE_DEADLINE && phase <= PHASE.PLAYOFFS) ||
		phase === PHASE.FANTASY_DRAFT ||
		phase === PHASE.EXPANSION_DRAFT ||
		!!gameOver ||
		!!otherTeamsWantToHire ||
		!!spectator ||
		!!challengeNoTrades
	);
};
